var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChat = function SvgChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10156 7.69815C1.10156 4.171 4.23946 1.40039 7.98585 1.40039C11.7301 1.40039 14.9001 4.17503 14.9001 7.7161C14.9001 11.2537 11.7639 14.0318 8.01578 14.0318L8.01432 14.0318C7.42637 14.0304 6.84085 13.9591 6.27006 13.8194L2.71167 14.53C2.15195 14.6418 1.6586 14.1483 1.77053 13.5886L2.25678 11.1574C1.5244 10.1568 1.11932 8.95124 1.10162 7.70668L1.10156 7.69815ZM2.30156 7.69389C2.31774 8.76416 2.6922 9.79818 3.36518 10.6307C3.47728 10.7693 3.52189 10.9507 3.48692 11.1255L3.06486 13.2358L6.1686 12.616C6.25846 12.5981 6.35123 12.6009 6.4398 12.6244C6.9543 12.7607 7.48419 12.8305 8.01645 12.8318C11.2107 12.8315 13.7001 10.4866 13.7001 7.7161C13.7001 4.94894 11.1843 2.60039 7.98585 2.60039C4.79125 2.60039 2.30413 4.93859 2.30156 7.69389Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.f746b2ad806041ce8d49b403fcf2f88e.svg";